'use strict';

module.exports = {
    ACTIVE: 'active',
    STARTING: 'STARTING',
    IN_PROGRESS: 'IN PROGRESS',
    ERROR: 'ERROR',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    RETRY_ERROR: 'RETRY ERROR'
};